module.exports = __webpack_public_path__ + "img/properties-gaoubouzi-bouzi-project.cc811aaa.png";